module.exports = function getResource(label) {
    let resources = {
        pleaseUpdateInfoMessage: 'Please update your information'
    };

    return resources[label];
};
